import React from 'react'
import { format } from 'date-fns'
import { NavLink as RouterLink } from 'react-router-dom'

import * as Navigation from 'pages/Programming/components/Navigation'
import { Tabs, Tab } from 'components/Tabs'

function formatDate(date: Date) {
  return format(date, 'eee, MMM dd')
}

type Props = {
  date: Date
  slugs: {
    weeklyOverview: string
    previousDay?: string
    nextDay?: string
    atHomeTrack: string
    affiliateTrack: string
    competeTrack: string
    liftingTrack: string
  }
}

function DailyClassPlanNavigation({ date, slugs }: Props) {
  const atHomeLiftingCutoffDate = new Date('Mon, 03 Jul 2023 00:00:00 GMT')
  const atHomeLiftingAvailable = date < atHomeLiftingCutoffDate
  const nextDay = new Date(date)
  nextDay.setDate(date.getDate() + 1)
  const forwardNavigationDisabled =
    nextDay >= atHomeLiftingCutoffDate &&
    (slugs?.nextDay?.includes('lifting') || slugs?.nextDay?.includes('at-home'))

  return (
    <Navigation.Wrapper backLinkTo={slugs.weeklyOverview}>
      <Navigation.Title
        previousTo={slugs.previousDay}
        nextTo={forwardNavigationDisabled ? null : slugs.nextDay}
      >
        {formatDate(date)}
      </Navigation.Title>
      <Tabs aria-label='tracks'>
        <Tab as={RouterLink} to={slugs.affiliateTrack}>
          Affiliate
        </Tab>
        {atHomeLiftingAvailable && (
          <Tab as={RouterLink} to={slugs.atHomeTrack}>
            At Home
          </Tab>
        )}

        <Tab as={RouterLink} to={slugs.competeTrack}>
          Compete
        </Tab>
        {atHomeLiftingAvailable && (
          <Tab as={RouterLink} to={slugs.liftingTrack}>
            Lifting
          </Tab>
        )}
      </Tabs>
    </Navigation.Wrapper>
  )
}

export default DailyClassPlanNavigation
